// React
import React, { useState } from "react";

// Bootstrap
import { Form } from "react-bootstrap";
// import { Modal, Button } from "react-bootstrap";

import { Modal, Button } from "antd";

// Components
import ListSelectionTypeahead from "../components/ListSelectionTypeahead";

// Libs
import * as EventifyAPI from "../libs/EventifyAPI";

// AWS
import { Auth } from "aws-amplify";
import { setSeconds } from "date-fns";

export default function AccountModal(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [currentListId, setCurrentListId] = useState(null);

  function validateForm() {
    // return fields.email.length > 0 && fields.password.length > 0;
    return true;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    // try {
    //   await Auth.signIn(fields.email, fields.password);
    //   props.userHasAuthenticated(true);
    //   props.history.push("/");
    // } catch (e) {
    //   alert(e.message);
    //   setIsLoading(false);
    // }
  }

  async function addItems() {
    if (selectedTabKey == "contact") {
      const selectedIndividualContacts = selectedPersons;
      // const result = await EventifyAPI.addRemovePersonsToList(props.email, currentListId, selectedIndividualContacts, true);
    } else if (selectedTabKey == "list") {
      const listidsonly = selectedLists.map((item, n) => {
        return item.listid;
      });
      for (var k = 0; k < listidsonly.length; k++) {
        const listid = listidsonly[k];
        const result = await EventifyAPI.addListToList(
          currentListId,
          listid
        );
      }
    }
    window.location.reload();
  }

  async function removeItems() {
    if (selectedTabKey == "contact") {
      const selectedIndividualContacts = selectedPersons;
      // const result = await EventifyAPI.addRemovePersonsToList(props.email, currentListId, selectedIndividualContacts, false);
    } else if (selectedTabKey == "list") {
      const listidsonly = selectedLists.map((item, n) => {
        return item.listid;
      });
      // const result = await EventifyAPI.addRemoveListsToList(props.email, currentListId, listidsonly, false);
    }
    window.location.reload();
  }

  var selectedLists = [];
  async function onUpdateListSelection(selected) {
    //
    selectedLists = selected;
  }

  var selectedPersons = [];
  async function onUpdatePersonSelection(selected) {
    //
    selectedPersons = selected;
  }

  var selectedTabKey = "list";
  function selectedTab(tabKey) {
    //
    selectedTabKey = tabKey;
  }

  function onInputChange(value) {
    //
  }

  function inListAlready(personid) {
    return false;
  }

  function onOk() {
    // do something

    // then close
    if (props.onOk) {
      props.onOk();
    } else {
      props.onCancel();
    }
  }

  function onCancel() {
    // then close
    props.onCancel()
  }

  return (
    <Modal
      visible={props.visible}
      title={"Add or Remove Contacts from this List"}
      onOk={onOk}
      onCancel={onCancel}
      animation={true}
      className="list-edit-modal"
      footer={[
        <Button type="primary" onClick={addItems}>
          Finish
        </Button>
      ]}
    >
      <div className="input-label">
        <svg
          width="19"
          height="17"
          viewBox="0 0 19 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 4C3.32843 4 4 3.32843 4 2.5C4 1.67157 3.32843 1 2.5 1C1.67157 1 1 1.67157 1 2.5C1 3.32843 1.67157 4 2.5 4Z"
            stroke="#2D323F"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.07501 2.42502H18.325"
            stroke="#2D323F"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.5 10C3.32843 10 4 9.32843 4 8.5C4 7.67157 3.32843 7 2.5 7C1.67157 7 1 7.67157 1 8.5C1 9.32843 1.67157 10 2.5 10Z"
            stroke="#2D323F"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.07501 8.42499H18.325"
            stroke="#2D323F"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.5 16C3.32843 16 4 15.3284 4 14.5C4 13.6716 3.32843 13 2.5 13C1.67157 13 1 13.6716 1 14.5C1 15.3284 1.67157 16 2.5 16Z"
            stroke="#2D323F"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.07501 14.425H18.325"
            stroke="#2D323F"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <p>Select lists to add or remove</p>
      </div>
      <div className="modal-row">
        <p className="add">Add</p>
        <ListSelectionTypeahead
          id="includeLists"
          onUpdate={onUpdateListSelection}
          email={props.email}
          organizationid={props.organizationid}
        />
      </div>
      <div className="modal-row">
        <p className="remove">Remove</p>
        <ListSelectionTypeahead
          id="removeLists"
          onUpdate={onUpdateListSelection}
          email={props.email}
          organizationid={props.organizationid}
        />
      </div>
      {/* <Button variant="primary" onClick={addItems}>
        Add [#] to the List
      </Button> */}
    </Modal>
  );
}
